import React, { ReactNode, useEffect } from "react";

import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { setKey } from "react-geocode";
import { environment } from "../../environment";

interface IMapProviderProps {
  children: ReactNode;
}

const MapProvider: React.FC<IMapProviderProps> = ({ children }) => {
  const API_KEY = environment.googleApiKey;
  const libraries: Libraries = ["places", "geocoding", "maps"];

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: API_KEY ? API_KEY : "",
    libraries,
  });

  useEffect(() => {
    setKey(API_KEY ? API_KEY : "");
  }, [API_KEY]);

  return <>{isLoaded && children}</>;
};

export default MapProvider;
